<template>
	<div class="eip-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('eip.text.eip')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.EIP_URL" target="_blank">{{ $t('eip.help.doc') }}</a>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新、地域、申请-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in region_map" :key="index" :label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="jump_to_create()">
									{{ $t('eip.text.apply') }}
								</el-button>
							</el-form-item>
						</el-form>
						<!--搜索、筛选标签、自定义、下载-->
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<el-form-item>
								<el-input v-entire-placeholder @keyup.enter.native="updateList('refresh')"
									:placeholder="currentPlaceholder" v-model="currentSearchValue" style="width:412px">
									<el-select slot="prepend" id="my-select" v-model="currentSearch" @change="changeSearch"
										:placeholder="$t('listPage.placeholder.choose')" style="width:105px">
										<el-option class="my-select-input" v-for="item in searchSelect"
											:key="item.searchValue" :label="item.searchLabel" :value="item.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-input>
							</el-form-item>
							<el-form-item>
								<jcb-tag-filter :service-code="ServiceCodeConstant.CPSEIP"
									:visible.sync="batchEditTagDialogVisible" :region-id="region ? region : ''"
									@checkedTags="filterWithCheckedTags">
								</jcb-tag-filter>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-setting" class="jc-button-icon cps-custom-icon"
									@click="customVisible = true" :title="$t('listPage.text.customList')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-button class="jc-button-icon cps-custom-icon" icon="jc-icon-download"
									@click="exportList" :title="$t('listPage.text.exportList')">
								</el-button>
							</el-form-item>
						</el-form>

					</div>
					<!--弹性公网IP列表-->
					<el-table @filter-change="filterChange" :data="tableData" style="width:100%"
						class="jc-list-table jc-table-header-cell" v-loading="refreshLoading" ref="listTable"
						:empty-text="$t('speechCraft.listEmptyText')">
						<!--公网IP ID/地址-->
						<el-table-column :label="$t('eip.text.publicIdOrAddress')" min-width="230" key="id"
							v-if="customInfo !== null && customInfo['id'].selected">
							<template slot-scope="scope">
								<!--公网IP ID-->
								<el-tooltip class="item" effect="dark" :content="scope.row.elasticIpId" placement="top">
									<span>{{ scope.row.elasticIpId | maybeEmpty }}</span>
								</el-tooltip>
								<br />
								<!--地址-->
								<el-tooltip class="item" effect="dark" :content="scope.row.elasticIp" placement="top">
									<a href="javascript:void(0)"
										@click="jumpToDetail(scope.row.elasticIpId, scope.row.region)">{{
											scope.row.elasticIp
											| maybeEmpty }}</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--线路-->
						<el-table-column prop="lineType" min-width="70" :label="$t('eip.text.line')"
							v-if="customInfo !== null && customInfo['line'].selected">
							<template slot-scope="scope">
								<span>{{ scope.row.lineTypeName | maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--可用区-->
						<el-table-column prop="az" min-width="70" key="az" :label="$t('listPage.tableLabel.availableArea')"
							v-if="customInfo !== null && customInfo['az'].selected">
							<template slot-scope="scope">
								<span>{{ $t('eip.text.allAz') }}</span>
							</template>
						</el-table-column>
						<!--状态-->
						<el-table-column :label="$t('eip.text.status')" min-width="90" key="status" prop="status"
							:filters="statusFilter" :filter-method="filterStatus" :filter-multiple="false"
							column-key="status" filter-placement="bottom-start"
							v-if="customInfo !== null && customInfo['state'].selected">
							<template slot-scope="scope">
								<span :class="scope.row.status === 'associate' ? 'associate' : 'disassociate'">{{
									scope.row.statusName
									|
									maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--实例类型-->
						<el-table-column prop="instanceType" min-width="100" key="instanceType"
							:label="$t('eip.text.instanceType')" v-if="customInfo !== null && customInfo['type'].selected">
							<template slot-scope="scope">
								<span>{{ scope.row.instanceType ?
									InstanceTypeConstant[scope.row.instanceType.toUpperCase()] : '' |
									maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--实例名称-->
						<el-table-column prop="name" :label="$t('detail.text.name')" min-width="110" key="name"
							v-if="customInfo !== null && customInfo['name'].selected" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span>{{ scope.row.instanceName | maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--带宽上限-->
						<el-table-column min-width="105" key="bandwidth" prop="bandwidth"
							:label="$t('eip.text.bandwidthLimit')" v-if="customInfo !== null && customInfo['bw'].selected">
							<template slot-scope="scope">
								<span class="english-wrap">
									{{ scope.row.bandwidth + 'Mbps' }}
								</span>
								<p>
									{{ scope.row.bandwidthPackageId ? $t('eip.text.bandwidthPackage') :
										$t('eip.text.independentBandwidth') }}
								</p>
							</template>
						</el-table-column>
						<!--计费信息-->
						<el-table-column key="charge" min-width="200" :label="$t('listPage.tableLabel.billingInformation')"
							v-if="customInfo !== null && customInfo['fee'].selected">
							<template slot-scope="scope">
								<div v-if="scope.row.expire !== undefined">
									<p>{{ scope.row.chargeModeName }}
										<span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="red">{{ '(' +
											$t('listPage.text.hasExpired') + ')' }}
										</span>
									</p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
									<p v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.retireTime"
										class="list-expire-p red">{{ scope.row.retireTime + ' ' +
											$t('listPage.text.freed') }}</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'will-expire'" class="list-expire-p red">
										{{ scope.row.expire + ' ' +
											$t('listPage.text.expired') }}</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'available'" class="list-expire-p">
										{{ scope.row.expire + ' ' +
											$t('listPage.text.expired') }}</p>
								</div>
								<div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
									<p>
										{{ scope.row.chargeModeName }}
										<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
											class="red">
											{{ '(' + $t('privateNetInstance.arrear') + ')' }}
                                            <p class="list-expire-p bill-info-tip" style="color: #000000a6;"
                                                v-if="scope.row.charge.chargeStartTime">
                                                {{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
                                            </p>
										</span>
                                        <!-- <p class="list-expire-p bill-info-tip"
                                            v-if="scope.row.charge.chargeStartTime">
                                            {{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
                                        </p> -->
									</p>
									<p class="list-expire-p bill-info-tip"
										v-if="scope.row.charge.chargeStatus === 'normal'">
										{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
									</p>
									<p class="list-expire-p red"
										v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
										{{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
									</p>
								</div>
								<div v-else>
									<span>--</span>
								</div>
							</template>
						</el-table-column>
						<!-- 标签 -->
						<el-table-column :label="$t('listPage.text.tags')" key="tag"
							v-if="customInfo !== null && customInfo['tags'].selected" min-width="80"
							:show-overflow-tooltip="true" class-name="p-line-break">
							<template slot-scope="scope">
								<p>{{ scope.row.tagPairs | maybeEmpty }}</p>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column key="operation" min-width="135" :label="$t('listPage.tableLabel.operation')"
							v-if="customInfo !== null && customInfo['operation'].selected">
							<template slot-scope="scope">
								<!--状态未绑定，打开绑定资源弹框-->
								<a href="javascript:void(0)" @click="openBindSourceDialog(scope.row)"
									v-if="scope.row.status === 'disassociate'" class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus }">
									{{ $t('eip.text.bindSource') }}
									<!--实例停服不支持操作-->
									<div class="cps-form-tip add-ip-tip"
										v-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
									<!--无计费信息不支持操作-->
									<div class="cps-form-tip add-ip-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
								</a>
								<!--状态绑定，打开解绑资源弹框-->
								<a href="javascript:void(0)" @click="openUnBindSourceDialog(scope.row)"
									v-if="scope.row.status === 'associate'" class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus }">
									{{ $t('eip.text.unbindSource') }}
									<!--实例停服不支持操作-->
									<div class="cps-form-tip add-ip-tip"
										v-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
									<!--无计费信息不支持操作-->
									<div class="cps-form-tip add-ip-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
								</a>
								<!--更多-->
								<el-dropdown size="200px">
									<span class="jc-dropdown-link">
										{{ $t('operations.more') }}<i class="jc-icon-caret-bottom jc-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown" class="operation-list-dropdown-menu">
										<!--打开修改带宽弹框-->
										<a href="javascript:void(0)" @click="openModifyBandwidthDialog(scope.row)"
											class="cps-select-form-item">
											<el-dropdown-item
												:disabled="OverdueConstantArray.includes(scope.row.chargeStatus) || !!scope.row.bandwidthPackageId || !scope.row.chargeStatus">
												{{ $t('eip.text.modifyBandwidth') }}
											</el-dropdown-item>
											<!--已加入共享带宽不支持修改带宽-->
											<div class="cps-form-tip" v-if="scope.row.bandwidthPackageId">
												{{ $t('eip.help.joinSharedBandwidthNotAllowedModify') }}
											</div>
											<!--实例停服不支持操作-->
											<div class="cps-form-tip add-ip-tip"
												v-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--打开加入共享带宽弹框-->
										<a href="javascript:void(0)" @click="openJoinShareBandwidthDialog(scope.row)"
											class="cps-select-form-item">
											<el-dropdown-item v-if="!scope.row.bandwidthPackageId"
												:disabled="OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !scope.row.chargeStatus">
												{{ $t('eip.text.joinShareBandwidth') }}
											</el-dropdown-item>
											<!--包年包月不支持加入共享带宽-->
											<div class="cps-form-tip"
												v-if="!scope.row.bandwidthPackageId && scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
												{{ $t('eip.help.paidByDurationJoinSharedBandwidthNotAllowed') }}
											</div>
											<!--实例停服不支持操作-->
											<div class="cps-form-tip add-ip-tip"
												v-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--打开移除共享带宽弹框-->
										<a href="javascript:void(0)" class="cps-select-form-item"
											@click="selectOpts(EipOperationConstant.REMOVESHARED, scope.row, 'removeshared',
												!scope.row.bandwidthPackageId || !scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus))">
											<el-dropdown-item v-if="scope.row.bandwidthPackageId"
												:disable="!scope.row.bandwidthPackageId || !scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('eip.text.removeShareBandwidth') }}
											</el-dropdown-item>
											<!--实例停服不支持操作-->
											<div class="cps-form-tip add-ip-tip"
												v-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--跳转到续费页面-->
										<a href="javascript:void(0)"
											@click="selectOpts(EipOperationConstant.RENEW, scope.row, 'renew', !!scope.row.bandwidthPackageId || !scope.row.chargeStatus)"
											class="cps-select-form-item">
											<el-dropdown-item
												:disabled="!!scope.row.bandwidthPackageId || !scope.row.chargeStatus">
												{{ $t('operations.renew.name') }}
											</el-dropdown-item>
											<!--已加入共享带宽不支持续费-->
											<div class="cps-form-tip" v-if="scope.row.bandwidthPackageId">
												{{ $t('eip.help.joinSharedBandwidthNotAllowedRenew') }}
											</div>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--编辑标签-->
										<a class="cps-select-form-item" href="javascript:void(0)"
											@click="selectOpts(EipOperationConstant.EDITTAG, scope.row, 'editTag', !scope.row.chargeStatus)">
											<el-dropdown-item :disabled="!scope.row.chargeStatus">
												{{ $t('operations.edit_tag.name') }}
											</el-dropdown-item>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--删除eip-->
										<a class="cps-select-form-item" href="javascript:void(0)"
											@click="openDeleteEipDialog(scope.row)">
											<el-dropdown-item :disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
												|| (scope.row.status === 'associate'
													&& scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION && !scope.row.bandwidthPackageId) || !!scope.row.bandwidthPackageId
												|| !scope.row.chargeStatus || scope.row.nat">
												{{ $t('operations.delete.name') }}
											</el-dropdown-item>
											<!--包年包月不支持删除-->
											<div class="cps-form-tip"
												v-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
												{{ $t('eip.help.paidByDurationDeleteNotAllowed') }}
											</div>
											<!--已绑定资源不支持删除（非nat）-->
											<div class="cps-form-tip"
												v-if="scope.row.status === 'associate'
													&& scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION && !scope.row.bandwidthPackageId && !scope.row.nat">
												{{ $t('eip.help.boundDeleteNotAllowed') }}
											</div>
											<!--已绑定nat资源不支持删除-->
											<div class="cps-form-tip" v-if="scope.row.nat">
												{{ $t('eip.help.bindNatDeleteNotAllowed') }}
											</div>
											<!--已加入共享带宽不支持删除-->
											<div class="cps-form-tip" v-if="scope.row.bandwidthPackageId">
												{{ $t('eip.help.shareDeleteNotAllowed') }}
											</div>
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
			<!--绑定资源-->
			<bind-source :dialog-visible="bindDialogVisible" @ifDialogVisible="syncBindDialog" :eip-id="currentRowEipId"
				:region="currentRowRegion" @refreshList="updateList('refresh')">
			</bind-source>
			<!--解绑资源-->
			<un-bind-source :visible.sync="unBindSourcedDialogVisible" @ifDialogVisible="syncUnbindDialog" :region="region"
				:rowInfo="currentRow" @refresh="updateList('refresh')">
			</un-bind-source>
			<!--调整带宽-->
			<modify-bandwidth :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialog"
				:detail-data="currentRow">
			</modify-bandwidth>
			<!--加入共享带宽-->
			<join-sharebandwidth :dialog-visible.sync="joinShareBandwidthDialogVisible" :detail-data="currentRow"
				:region="region" @refreshPage="updateList('refresh')">
			</join-sharebandwidth>
			<!--编辑标签-->
			<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSEIP"
				:region-id="currentRow.region ? currentRow.region : ''"
				:resource-ids="currentRow.elasticIpId ? [currentRow.elasticIpId] : []" @complete="updateList('refresh')">
			</jcb-tag-edit>
			<!--删除eip-->
			<delete-eip :visible.sync="deleteEipVisible" @refresh="updateList('refresh')" :rowInfo="currentRow"
				:pageSource="'list'">
			</delete-eip>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	NetworkTypeConstant,
	EipOperationConstant,
	InstanceTypeConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ServiceCodeConstant,
	ChargeModeConstant
} from '@/common/Constants';
import custom from '@/components/common/custom/Custom';
import BindSource from '@/components/eip/bindSource/BindSource';
import UnBindSource from '@/components/eip/UnBindSource';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import JoinSharebandwidth from '@/components/common/joinShareBandwidth/JoinShareBandwidth';
import DeleteEip from '@/components/common/DeleteEip';

const initPage = 1;

export default {
	name: 'EipList',
	components: {
		custom,
		BindSource,
		UnBindSource,
		ModifyBandwidth,
		JoinSharebandwidth,
		DeleteEip
	},
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'ipAddress',
				searchLabel: this.$t('eip.text.ipAddress')
			},
			{
				searchValue: 'ipId',
				searchLabel: this.$t('eip.text.ipId')
			}
		];
		return {
			clientToken: Normal.getClientToken(),
			networkTypeMap: {
				basic: this.$t('listPage.text.baseNet')
			},
			chargeModeMap: {
				prepaid_by_duration: this.$t('listPage.text.prepaid_by_duration'),
				postpaid_by_duration: this.$t('listPage.text.postpaid_by_duration')
			},
			currentPage: initPage,
			initPage,
			form: {},
			region_map: [],
			region: null,
			tableData: [],
			// dialog公网
			refreshLoading: false,
			regionMap: {},
			minBandwidth: 0,
			idSearch: '',
			nameSearch: '',
			search: 'instanceId',
			currentSearch: 'ipAddress',
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('eip.placeholder.search.ipAddress'),
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// 公网IP ID/地址
					label: this.$t('eip.text.publicIdOrAddress'),
					value: 'id'
				},
				{
					// 线路
					label: this.$t('eip.text.line'),
					value: 'line'
				},
				{
					// 可用区
					label: this.$t('listPage.tableLabel.availableArea'),
					value: 'az'
				},
				{
					// 状态
					label: this.$t('list.status'),
					value: 'state'
				},
				{
					// 实例类型
					label: this.$t('eip.text.instanceType'),
					value: 'type'
				},
				{
					// 实例名称
					label: this.$t('detail.text.name'),
					value: 'name'
				},
				{
					// 带宽上限
					label: this.$t('eip.text.bandwidthLimit'),
					value: 'bw'
				},
				{
					// 计费信息
					label: this.$t('list.chargeInfo'),
					value: 'fee'
				},
				{
					// 标签
					label: this.$t('listPage.text.tags'),
					value: 'tags'

				},
				{
					// 操作
					label: this.$t('listPage.tableLabel.operation'),
					value: 'operation'
				}
			],
			// 自定义列表类型
			type: 'eipList',
			// 筛选条件
			statusFilter: [],
			// 绑定资源弹框是否可见
			bindDialogVisible: false,
			// 解绑资源弹框是否可见
			unBindSourcedDialogVisible: false,
			// 修改带宽弹框是否可见
			modifyDialogVisible: false,
			// 加入共享带宽弹框是否可见
			joinShareBandwidthDialogVisible: false,
			// 选择的状态筛选条件的值
			filteredStatus: '',
			// 当前行的EIP ID
			currentRowEipId: '',
			// 当前行的实例名称
			currentRowInstanceName: '',
			// 当前行的EIP IP
			currentRowEipIp: '',
			// 当前行的instanceId
			currentRowInstanceId: '',
			// 当前行的Region
			currentRowRegion: '',
			// 当前行所有数据
			currentRow: {},
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			// 删除eip弹框
			deleteEipVisible: false,
			// 当前页面类型 list detail
			pageType: 'list'
		};
	},
	computed: {
		ServiceCodeConstant: () => ServiceCodeConstant,
		customInfo() {
			return this.$store.state.customInfo[this.type];
		},
		InstanceTypeConstant: () => InstanceTypeConstant,
		EipOperationConstant: () => EipOperationConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		ArrearConstantArray: () => ArrearConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
	},
	watch: {
		region(newValue) {
			if (newValue) {
				this.regionChange();
			}
		},
	},
	created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
	},
	mounted() {
		this.getRegion();
	},

	methods: {
		/**
		 * 判断当前时间与到期、释放时间关系
		 * @param row
		 * @return {string}
		 */
		getCheckExpireInfo(row) {
			if (row.charge.chargeExpiredTime !== undefined) {
				const now = Date.now();
				const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
				const DAYS = 1000 * 60 * 60 * 24;
				if (now > expire && row.charge.chargeRetireTime) {
					return 'will-retire';
				}
				if (expire - now > 7 * DAYS) {
					return 'available';
				}
				return 'will-expire';
			}
		},
		// 获取弹性IP数据
		getEipListData() {
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			// 搜索部分添加参数
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'ipId': {
						param.elasticIpIds = this.currentSearchValue;
						break;
					}
					case 'ipAddress': {
						param.elasticIps = this.currentSearchValue;
						break;
					}
				}
			}

			if (this.filteredResourceIds.length !== 0) {
				param.elasticIpIds = this.filteredResourceIds.join(',');
			}
			// 状态筛选参数
			if (this.filteredStatus !== '') {
				param.status = this.filteredStatus;
			}

			Ajax.get('api/cps/listElasticIps', param).then(res => {
				const list = res.data.elasticIps;
				list.map(item => {
					item.chargeModeName = this.chargeModeMap[item.charge.chargeMode];
					item.chargeMode = item.charge.chargeMode;
					item.expire = item.charge.chargeExpiredTime;
					item.retireTime = item.charge.chargeRetireTime;
					item.chargeStatus = item.charge.chargeStatus;
					item.tagPairs = '';
					if (item.tags !== undefined && item.tags.length > 0) {
						for (const tag of item.tags) {
							item.tagPairs += `${tag.key}:${tag.value},`;
						}
						item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
					}
					return item;
				});
				this.tableData = list;
				this.total = res.data.totalCount;
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					// this.$message.error(json.errmsg);
					this.tableData = [];
					this.total = 0;
				} catch (ex) {
					console.log(ex);
				}
			})
				.finally(() => {
					this.refreshLoading = false;
				});
		},
		getRegion() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
					res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.region_map.push(tempFormat);
					});
				}
			})
				.catch()
				.finally(() => {
					this.loading = false;
				});
		},
		updateList(type) {
			if (type === 'refresh') {
				this.refreshLoading = true;
				this.currentPage = 1;
			}
			this.getEipListData();
		},
		filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
			if (tagKeys.length !== 0) {
				this.filteredResourceIds = resourceIds;
			} else {
				this.filteredResourceIds = [];
			}
			this.updateList();
		},
		// 选择地区
		regionChange() {
			this.$refs.listTable.clearFilter();
			this.currentSearchValue = '';
			this.getFilterLists();
			this.updateList('refresh');
		},
		// 跳转到详情页
		jumpToDetail(id, region) {
			this.$router.push({
				path: `/eip/detail/${id}/${region}`,
			});
		},
		// 跳转到创建页
		jump_to_create() {
			this.$router.push({
				path: '/eip/create',
				query: {
					region: this.region
				}
			});
		},
		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('eip.placeholder.search');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},
		// 导出列表接口
		exportList() {
			let temp = '';
			const target = this;
			if (target.currentSearchValue !== '') {
				switch (target.currentSearch) {
					case 'ipAddress': {
						temp = `&elasticIps=${target.currentSearchValue}`;
						break;
					}
					case 'ipId': {
						temp = `&elasticIpIds=${target.currentSearchValue}`;
						break;
					}
				}
			}

			if (target.filteredStatus !== '' && target.filteredStatus !== undefined) {
				temp += `&status=${target.filteredStatus}`;
			}
			const url = `/cps_api/api/export/listElasticIps?pageNumber=${target.currentPage}&pageSize=${target.pageSize}&region=${target.region}${temp}`;
			window.open(url, '_self');
		},
		// 切换每一页多少条
		handleSizeChange(val) {
			this.pageSize = val;
			this.updateList('refresh');
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getEipListData();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get({
				url: '/api/usercenter',
				action: '/getCustomInfo',
				param,
				success: (data) => {
					if (data.customInfo) {
						this.$store.commit('GET_CUSTOMINFO', { value: data.customInfo, type: this.type });
					}
				}
			});
		},
		filterChange(filter) {
			this.currentPage = 1;
			for (const key in filter) {
				switch (key) {
					case 'status': {
						this.filteredStatus = filter[key][0];
					}
				}
			}
			this.getEipListData();
		},
		openBindSourceDialog(row) {
			if (OverdueConstantArray.includes(row.chargeStatus) || !row.chargeStatus) {
				return false;
			}
			this.currentRowEipId = row.elasticIpId;
			this.currentRowInstanceName = row.instanceName;
			this.currentRowRegion = row.region;
			this.bindDialogVisible = true;
		},
		openUnBindSourceDialog(row) {
			if (OverdueConstantArray.includes(row.chargeStatus) || !row.chargeStatus) {
				return false;
			}
			this.currentRow = row;
			this.unBindSourcedDialogVisible = true;
		},
		openModifyBandwidthDialog(row) {
			if (OverdueConstantArray.includes(row.chargeStatus) || row.bandwidthPackageId || !row.chargeStatus) {
				return false;
			}
			this.currentRow = row;
			this.modifyDialogVisible = true;
		},
		openJoinShareBandwidthDialog(row) {
			if (OverdueConstantArray.includes(row.chargeStatus) || row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !row.chargeStatus) {
				return false;
			}
			this.currentRow = row;
			this.joinShareBandwidthDialogVisible = true;
		},
		openDeleteEipDialog(row) {
			if (row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || (row.status === 'associate' && row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION) || row.bandwidthPackageId || !row.chargeStatus || row.nat) {
				return false;
			}
			this.currentRow = row;
			this.deleteEipVisible = true;
		},
		// 按照绑定、未绑定状态进行搜索
		filterStatus(value, row) {
			return row.status === value;
		},
		// 获取弹性IP列表过滤字典
		getFilterLists() {
			const param = {
				region: this.region
			};
			Ajax.get({
				url: '/api/filter',
				action: '/listElasticIps',
				param,
				success: (data) => {
					const filterObject = {};
					if (data) {
						for (const key in data) {
							filterObject[key] = [];
							for (const innerKey in data[key]) {
								const temp = {
									value: innerKey,
									text: data[key][innerKey]
								};
								filterObject[key].push(temp);
							}
						}
						this.statusFilter = filterObject.status;
					}
				},
			});
		},

		// 同步绑定资源子组件传出来的dialog是否展示
		syncBindDialog(data) {
			this.bindDialogVisible = data;
		},
		// 同步解绑资源子组件传出来的dialog是否展示
		syncUnbindDialog(data) {
			this.unBindSourcedDialogVisible = data;
		},
		// 同步修改带宽子组件传出来的dialog是否显示
		syncModifyDialog(data) {
			this.modifyDialogVisible = data;
		},
		// 同步修改加入共享带宽子组件传出来的dialog是否显示
		syncShareBandwidthDialog(data) {
			this.joinShareBandwidthDialogVisible = data;
		},
		// 更多中的操作
		selectOpts(caseOps, cps, operate, disabled, otherDisabled) {
			if (disabled || otherDisabled) {
				return;
			}
			EipPopHelper.operations(caseOps, this, cps, 'list');
		},
	}
};
</script>


<style lang="scss">
@import '../../../assets/scss/listComon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/eip/list/List.vue